import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getFirestore, collection, query, where, getDocs, doc, deleteDoc } from "firebase/firestore";
import styles from './ProjectPage.module.css';
import { ProjectPosts } from './Components/ProjectPosts';
import Sidebar from './Components/sidebar'; // The Sidebar component we discussed earlier

function ProjectPage() {
    const location = useLocation();
    const navigate = useNavigate();
    const db = getFirestore();

    const projectName = location.state?.projectName || "Default Project Name";
    const projectId = location.state?.projectId;
    const [currentPage, setCurrentPage] = useState('project-setup'); // Add this line to define currentPage state


    const navigateToComponents = () => {
        window.location.href = 'https://framer.com/projects/new?duplicate=ROjVALyAU0hTrkJMcVxV';
    };

    const [users, setUsers] = useState([]);

    const [showUpgradeModal, setShowUpgradeModal] = useState(false);
    // const [selectedSegment, setSelectedSegment] = useState('Users');

    const toggleUpgradeModal = () => {
        setShowUpgradeModal(!showUpgradeModal);
    };

    const handleDeleteUser = async (userId) => {
        if (window.confirm("Are you sure you want to delete this user from the project?")) {
            try {
                await deleteDoc(doc(db, "users", userId));
                setUsers(users.filter((user) => user.id !== userId));
                alert("User successfully deleted from the project.");
            } catch (error) {
                console.error("Error deleting user: ", error);
                alert("Failed to delete user from the project.");
            }
        }
    };
    

    useEffect(() => {
        const db = getFirestore();
        const fetchUsers = async () => {
            const db = getFirestore();
            const usersRef = collection(db, "users");
            const q = query(usersRef, where("projects", "array-contains", projectId));

            const querySnapshot = await getDocs(q);
            const usersData = [];
            querySnapshot.forEach((doc) => {
                usersData.push({
                    id: doc.id,
                    email: doc.data().email
                });
            });
            setUsers(usersData);
        };

        if (projectId) {
            fetchUsers();
        }

        const checkThresholds = async () => {
            // Example threshold check, replace with your actual logic
            if (users.length >= 100) {
                setShowUpgradeModal(true);
            }
        };

        if (projectId) {
            fetchUsers();
            checkThresholds();
        }

    }, [projectId, users.length]);


    const handleBack = () => {
        navigate('/dashboard');
    };

    const handleUserClick = (userId) => {
        navigate(`/user/${userId}`);
    };

    function copyToClipboard(text) {
        navigator.clipboard.writeText(text)
            .then(() => {
                alert('Project ID copied to clipboard!');
            })
            .catch(err => {
                console.error('Failed to copy text: ', err);
            });
    }

    // const renderHeader = () => (
    //     <div className={styles.detailsHeader}>
    //       <h1>{currentPage.charAt(0).toUpperCase() + currentPage.slice(1).replace('-', ' ')}</h1>
    //       <button onClick={() => copyToClipboard(projectId)}>Copy Project ID</button>
    //       <button onClick={navigateToComponents}>Start Building</button>
    //     </div>
    //   );

    const renderHeaderAndButtons = () => {
        let headerText;
        switch (currentPage) {
          case 'project-setup':
            headerText = `${projectName} Setup`; // Or "Project Setup" if that's the desired static title
            break;
          case 'users':
            headerText = 'Users';
            break;
          case 'user-data':
            headerText = 'User Data';
            break;
          default:
            headerText = '';
            break;
        }
      
        return (
          <div className={styles.projectHeaderContainer}>
            <h1 className={styles.projectHeader}>{headerText}</h1>
            <div className={styles.buttonContainer}>
              <button className={styles.projectIDButton} onClick={() => copyToClipboard(projectId)}>Copy Project ID</button>
              <button className={styles.stackFrameButton} onClick={navigateToComponents}>Start Building</button>
            </div>
          </div>
        );
      };
      
      // Function to render content based on the active page
      const renderContent = () => {
        let content;
        switch (currentPage) {
          case 'project-setup':
            content = 
            <div className={styles.instructionsContainer}>
                <div className={styles.Card}> 
                    <h3 className={styles.cardHeader}>Step 1</h3>
                    <p>Make sure you have your Framer account set up.</p>
                </div>
                <div className={styles.Card}> 
                    <h3 className={styles.cardHeader}>Step 2</h3>
                    <p>Start building by tapping the `Start Building` button in the top right of your screen. Remix the Framer File and build your App inside this file.  </p>
                </div>
                <div className={styles.Card}> 
                    <h3 className={styles.cardHeader}>Step 3</h3>
                    <p>Inside the Framer file you just remixed you will see additional instructions, along with all of the stackFrame components. Drag the stackFrame components you want to use into your Framer Website. Some of these components require a Project ID to function correctly. Tap on the Copy Project ID button in the top right to copy to your Project ID. </p>
                </div>
               
            </div>;
            break;
          case 'users':
            content = users.length > 0 ? (
              <ul>
                {users.map((user) => (
                  <li key={user.id} className={styles.projectRowStyle}>
                    {user.email}
                    <button
                      onClick={() => handleDeleteUser(user.id)}
                      className={styles.deleteButtonStyle}
                    >
                      🗑️
                    </button>
                  </li>
                ))}
              </ul>
            ) : (
              <div className={styles.centerMessage}>
                This project doesn't have any users signed up yet.
              </div>
            );
            break;
          case 'user-data':
            content = <ProjectPosts projectId={projectId}  />;
            break;
          default:
            content = <div>Select a page</div>;
        }
        return <div className={styles.UserDataContainer}>{content}</div>;
      };


      return (
        <div className={styles.projectContainer}>
          <Sidebar onSelect={setCurrentPage} activePage={currentPage} />
          <div className={styles.rightContainer}>
            {renderHeaderAndButtons()} {/* This line calls the renderHeader function */}
            <div className={styles.content}>
              {renderContent()}
            </div>
          </div>
        </div>
      );
    }
    // return (
    //     <div className={styles.projectContainer}>
    //         {showUpgradeModal && <UpgradeModal onClose={() => setShowUpgradeModal(false)} />}
    //         <div className={styles.mainWrapper}>
        
    //             <div className={styles.container}>
    //                 <div className={styles.leftContainer}>
    //                     <button className={styles.backButtonStyle} onClick={handleBack}>
    //                         <span className={styles.chevronIcon}>&lt;</span>
    //                         <span className={styles.buttonHeader}>Back</span>
    //                     </button>
    //                     <h1 className={styles.detailsHeader}>{projectName}</h1>
    //                     <div className={styles.projectIDContainer} onClick={() => copyToClipboard(projectId)}>
    //                         <p>Project ID: {projectId}</p>
    //                     </div>
    //                     <div className={styles.stackFrameContainer} onClick={navigateToComponents}
    //             style={{ cursor: 'pointer' }} >
    //                         View stackFrame Framer Components
    //                     </div>
    //                 </div>
    
    //                 <div className={styles.sideBySideContainer}>
    //             <div className={styles.rightContainer}>
    //                 <h2 className={styles.userHeader}>Users:</h2>
    //                 {users.length > 0 ? (
    //                     <ul>
    //                         {users.map((user) => (
    //                             <li key={user.id} className={styles.projectRowStyle}>
    //                                 {user.email}
    //                                 {/* Trashcan icon button */}
                                    
    //                                 <button
    //                                     onClick={() => handleDeleteUser(user.id)}
    //                                     className={styles.deleteButtonStyle}
    //                                 >
    //                                   🗑️ 
    //                                 </button>
    //                             </li>
    //                         ))}
    //                     </ul>
    //                 ) : (
    //                     <div className={styles.centerMessage}>
    //                         This project doesn't have any users signed up yet.
    //                     </div>
    //                 )}
    //             </div>
    //             <div>
    //                 <ProjectPosts projectId={projectId} />
    //             </div>
    //         </div>
    //             </div>
    //         </div>
    //     </div>
    // );
    


export default ProjectPage;



        
            {/* UPGRADE BUTTON FOR TESTING PURPOSES  */}
            {/* <button onClick={toggleUpgradeModal} className={styles.upgradeButton}>Upgrade Plan</button> */}
